var map = {
	"./Avatar-10.svg": "2448",
	"./Avatar-12.svg": "83da",
	"./Avatar-13.svg": "6804",
	"./Avatar-15.svg": "971e",
	"./Avatar-16.svg": "55ad",
	"./Avatar-19.svg": "879e",
	"./Avatar-27.svg": "b990",
	"./Avatar-30.svg": "a327",
	"./Avatar-8.svg": "20f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bfdc";